<template>
	<v-card class="padding">

        <!--edição -->
        <v-dialog v-model="form" persistent="" max-width="700">
            <v-card>
                <v-card-text>
                    <v-layout justify-space-between="" row="" wrap="">
                        <v-flex md5="">
                            <v-text-field ref="nome" :rules="[() =&gt; !!usuarioSelected.nome || 'Este campo é obrigatório']" v-model="usuarioSelected.nome" placeholder="Nome" label="Nome" color="blue-grey" required=""></v-text-field>
                        </v-flex>
                        <v-flex md5="">
                            <v-text-field ref="email" :rules="[() =&gt; /^[a-z0-9._]+@[a-z0-9]+.[a-z]+(.[a-z]+)?$/i.test(usuarioSelected.login) || 'Informe um e-mail válido']" v-model="usuarioSelected.login" placeholder="E-mail" label="E-mail" color="blue-grey" required=""></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout justify-space-between="" row="" wrap="">
                        <v-flex md5="">
                            <v-text-field ref="logradouro" :rules="[() =&gt; !!usuarioSelected.endereco.logradouro || 'Este campo é obrigatório']" v-model="usuarioSelected.endereco.logradouro" placeholder="Logradouro" label="Logradouro" color="blue-grey" required=""></v-text-field>
                        </v-flex>
                        <v-flex md5="">
                            <v-text-field ref="numero" :rules="[() =&gt; !!usuarioSelected.endereco.numero || 'Este campo é obrigatório']" v-model="usuarioSelected.endereco.numero" placeholder="Número" label="Número" color="blue-grey" required=""></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout justify-space-between="" row="" wrap="">
                        <v-flex md5="">
                            <v-text-field ref="bairro" :rules="[() =&gt; !!usuarioSelected.endereco.bairro || 'Este campo é obrigatório']" v-model="usuarioSelected.endereco.bairro" placeholder="Bairro" label="Bairro" color="blue-grey" required=""></v-text-field>
                        </v-flex>
                        <v-flex md5="">
                            <v-text-field ref="cidade" :rules="[() =&gt; !!usuarioSelected.endereco.cidade || 'Este campo é obrigatório']" v-model="usuarioSelected.endereco.cidade" placeholder="Cidade" label="Cidade" color="blue-grey" required=""></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout justify-space-between="" row="" wrap="">
                        <v-flex md5="">
                            <v-text-field ref="estado" v-model="usuarioSelected.endereco.estado" placeholder="Estado" required="" label="Estado" color="blue-grey"></v-text-field>
                        </v-flex>
                        <v-flex md5="">
                            <v-text-field @keypress="formatar('#####-###', $event)" ref="cep Ex: #####-###" :rules="[() =&gt; /^[0-9]{5}-[0-9]{3}$/.test(this.usuarioSelected.endereco.cep) || 'Informe um cep válido' ]" v-model="usuarioSelected.endereco.cep" placeholder="Cep Ex: #####-###" required="" label="Cep Ex: #####-###" color="blue-grey"></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-text-field ref="password" placeholder="password" label="password" color="blue-grey" v-model="usuarioSelected.password"></v-text-field>
                    <v-chip v-if="usuarioSelected._id"> Grupo Atual: {{buscaGrupo(usuarioSelected._id) || `Nenhum`}} </v-chip>

                    <v-select v-model="usuarioSelected.grupo_id" item-text="nome" color="blue-grey" item-value="_id" :items="getGrupos" label="Selecione o Grupo" ></v-select>
                    <v-text-field ref="telefonesadd" placeholder="Adicionar Telefone" label="Informe o telefone e pressione enter" v-model="tempfone" @keyup.enter="usuarioSelected.telefones.push(tempfone), tempfone=''" color="blue-grey"></v-text-field>
                    <v-chip :key="i" v-for="(t, i) in usuarioSelected.telefones">{{ t }}
                        <v-icon @click="usuarioSelected.telefones.splice(i, 1)" right="">clear</v-icon>
                    </v-chip>
                    <v-divider></v-divider>
                    <v-btn outline="" color="error" @click="form=false">Cancelar</v-btn>
                    <v-btn outline="" color="blue-grey" @click="update(usuarioSelected)" :disabled="!validate" dark=""> {{ usuarioSelected._id ? &apos;Alterar&apos; : &apos;Cadastrar&apos; }} </v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>


        <!-- cadastro -->
        <v-dialog v-model="dialog" persistent="" max-width="700">
            <v-card>
                <v-card-text>
                    <v-layout justify-space-between="" row="" wrap="">
                        <v-flex md5="">
                            <v-text-field ref="nome" :rules="[() =&gt; !!usuarioSelected.nome || 'Este campo é obrigatório']" v-model="usuarioSelected.nome" placeholder="Nome" label="Nome" color="blue-grey" required=""></v-text-field>
                        </v-flex>
                        <v-flex md5="">
                            <v-text-field ref="email" :rules="[() =&gt; /^[a-z0-9._]+@[a-z0-9]+.[a-z]+(.[a-z]+)?$/i.test(usuarioSelected.login) || 'Informe um e-mail válido']" v-model="usuarioSelected.login" placeholder="E-mail" label="E-mail" color="blue-grey" required=""></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout justify-space-between="" row="" wrap="">
                        <v-flex md5="">
                            <v-text-field ref="logradouro" :rules="[() =&gt; !!usuarioSelected.endereco.logradouro || 'Este campo é obrigatório']" v-model="usuarioSelected.endereco.logradouro" placeholder="Logradouro" label="Logradouro" color="blue-grey" required=""></v-text-field>
                        </v-flex>
                        <v-flex md5="">
                            <v-text-field ref="numero" :rules="[() =&gt; !!usuarioSelected.endereco.numero || 'Este campo é obrigatório']" v-model="usuarioSelected.endereco.numero" placeholder="Número" label="Número" color="blue-grey" required=""></v-text-field>
                        </v-flex>
                        <v-chip v-if="usuarioSelected.id"> Grupo Atual: {{descrevagrupo}} </v-chip>
                    </v-layout>
                    <v-layout justify-space-between="" row="" wrap="">
                        <v-flex md5="">
                            <v-text-field ref="bairro" :rules="[() =&gt; !!usuarioSelected.endereco.bairro || 'Este campo é obrigatório']" v-model="usuarioSelected.endereco.bairro" placeholder="Bairro" label="Bairro" color="blue-grey" required=""></v-text-field>
                        </v-flex>
                        <v-flex md5="">
                            <v-text-field ref="cidade" :rules="[() =&gt; !!usuarioSelected.endereco.cidade || 'Este campo é obrigatório']" v-model="usuarioSelected.endereco.cidade" placeholder="Cidade" label="Cidade" color="blue-grey" required=""></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout justify-space-between="" row="" wrap="">
                        <v-flex md5="">
                            <v-text-field ref="estado" v-model="usuarioSelected.endereco.estado" placeholder="Estado" required="" label="Estado" color="blue-grey"></v-text-field>
                        </v-flex>
                        <v-flex md5="">
                            <v-text-field @keypress="formatar('#####-###', $event)" ref="cep Ex: #####-###" :rules="[() =&gt; /^[0-9]{5}-[0-9]{3}$/.test(this.usuarioSelected.endereco.cep) || 'Informe um cep válido' ]" v-model="usuarioSelected.endereco.cep" placeholder="Cep Ex: #####-###" required="" label="Cep Ex: #####-###" color="blue-grey"></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-text-field ref="senha" placeholder="Senha" label="Senha" color="blue-grey" v-model="usuarioSelected.senha"></v-text-field>
                    <!--<v-chip v-if="usuarioSelected.id"> Grupo Atual: {{descrevagrupo}} </v-chip>-->
                    <v-select item-text="nome" color="blue-grey" item-value="_id" v-model="usuarioSelected.grupo_id" :items="getGrupos" label="Selecione o Grupo"></v-select>
                    <v-text-field ref="telefonesadd" placeholder="Adicionar Telefone" label="Informe o telefone e pressione enter" v-model="tempfone" @keyup.enter="usuarioSelected.telefones.push(tempfone), tempfone=''" color="blue-grey"></v-text-field>
                    <v-chip :key="i" v-for="(t, i) in usuarioSelected.telefones">{{ t }}
                        <v-icon @click="usuarioSelected.telefones.splice(i, 1)" right="">clear</v-icon>
                    </v-chip>
                    <v-divider></v-divider>
                    <v-btn outline="" color="error" @click="dialog=false">Cancelar</v-btn>
                    <v-btn outline="" color="blue-grey" @click="save(usuarioSelected)" :disabled="!validate" dark=""> {{ usuarioSelected._id ? &apos;Alterar&apos; : &apos;Cadastrar&apos; }} </v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>


         <h1 class="fonte">Gerenciamento de Usuários</h1>
        <p class="black--text">Escolha uma ação abaixo</p>
        <v-card-title>

            <v-btn class="white--text" color="fundo" v-if="$can('listarusuarios','cadastrarusuario')" @click="novo">
                <v-icon>add</v-icon>Cadastrar novo
            </v-btn>
            <v-tooltip color="fundo" v-if="!$can('listarusuarios','cadastrarusuario')" top>
                <v-btn slot="activator" class="white--text" disabled="true">
                    <v-icon>add</v-icon>Cadastrar novo
                </v-btn>
                <span class="subheading">Você não possui permissão de cadastrar usuário</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Buscar usuário"></v-text-field>
        </v-card-title>
        <div v-if="$can('listarusuarios', 'listarusuarios')">
            <v-data-table :headers="headers" :items="getUsuarios" :search="search" hide-actions>
                <template slot="items" slot-scope="props">
                    <td class="text-xs-left">{{ props.item.nome }}</td>
                    <td class="text-xs-left">{{ props.item.login }}</td>
                    <td class="text-xs-center">
                        <v-btn class="white--text elevation-0" fab small color="fundo" v-if="$can('listarusuarios','alterarusuario')" @click="editItem(props.item)">
                            <v-icon>create</v-icon>
                        </v-btn>
                        <v-tooltip v-if="!$can('listarusuarios','alterarusuario')" top>
                            <v-btn slot="activator" class="white--text" color="fundo" disabled="true">
                                <v-icon>create</v-icon>
                            </v-btn>
                            <span class="subheading">Você não possui permissão de alterar usuário</span>
                        </v-tooltip>

                        <v-btn class="white--text elevation-0" fab small color="error" v-if="$can('listarusuarios','removerusuario')" @click="deleteItem(props.item._id)">
                            <v-icon>delete</v-icon>
                        </v-btn>

                        <v-tooltip v-if="!$can('listarusuarios','removerusuario')" top>
                            <v-btn slot="activator" class="white--text" color="error" disabled="true">
                                <v-icon>delete</v-icon>
                            </v-btn>
                            <span class="subheading">Você não possui permissão de remover usuário</span>
                        </v-tooltip>
                    </td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">Sua pesquisa por: &quot;{{ search }}&quot; n&atilde;o obteve resultado</v-alert>
            </v-data-table>
        </div>
        <h1 class="text-xs-center headline mt-5" v-if="!$can('listarusuarios', 'listarusuarios')">Você não possui permissão de listar usuários</h1>
        <v-snackbar
        bottom
        right
        v-model="snackbar"
        color="fundo"
        >
        {{ mensagem }}
        <v-btn
            dark
            flat
            @click="snackbar = false"
        >
            <v-icon>close</v-icon>
        </v-btn>
        </v-snackbar>
    </v-card>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Mask from '../../../helpers/Mask'
import getCep from '../../../helpers/GetCep'

export default {
  mixins:[Mask],
  data()
  {
    return{
      tempfone:'',
      snackbar: false,
      mensagem: '',
      search:'',
      descrevagrupo:'',
      usuarioSelected:{
        empresa_id: '',
        _id: '',
        nome:'',
        email:'',
        senha:'',
        telefones:[],
        grupo_id:'',
        endereco:{
          logradouro:'',
          numero:'',
          bairro:'',
          cidade:'',
          estado:'',
          cep:''
        }
      },
      form: false,
      dialog: false,
      headers: [
        { text: 'Nome',  value: 'nome' },
        { text: 'E-mail', value: 'login' },
        { text: 'Ações', value: 'acoes', align: 'center' }
      ],
      usuarios: [
          {nome: 'Paulo', email: 'paulo@paulo.com'}
      ],
    }
  },
  mounted()
  {
    //carregar todos usuarios d@change="atualizaGrupo(usuarioSelected.grupo, usuarioSelected._id)"sa
  },
  methods:{
    ...mapActions(['listaUsuario', 'alteraUsuario', 'cadastraUsuario', 'deletaUsuario']),
    editItem(u)
    {
      this.form=true
      this.usuarioSelected = Object.assign({}, u)
    },
    deleteItem(user)
    {
      if(confirm("Tem certeza?"))
      {
          this.deletaUsuario(user).then(r => {
            this.snackbar = true
            this.mensagem = r.message
            this.listaUsuario()
          })
      }
    },
    /*getCep()
    {
      if(/^[0-9]{5}-[0-9]{3}$/.test(this.usuarioSelected.endereco.cep))
      {
        getCep(this.usuarioSelected.endereco.cep).then(r => {
          let {logradouro, bairro, localidade, uf } = r
          this.usuarioSelected.endereco.logradouro  = logradouro
          this.usuarioSelected.endereco.bairro      = bairro
          this.usuarioSelected.endereco.cidade      = localidade
          this.usuarioSelected.endereco.estado      = uf
        })
      }
    },*/
    novo()
    {
      this.dialog=true
      this.usuarioSelected={empresa_id: this.getUser.empresa_id,nome:'',login:'',senha: '', grupo_id: '', telefones:[],endereco:{logradouro:'',numero:'',bairro:'',cidade:'',estado:'',cep:''}}
      //this.usuarioSelected.empresa_id = getUser.empresa_id
    },
    save(user)
    {
        this.cadastraUsuario(user).then(r => {
            this.dialog = false
            this.snackbar = true
            this.mensagem = r.message
            this.listaUsuario()
        })
    },
    update(user)
    {
        this.alteraUsuario(user).then(r => {
            this.form = false
            this.snackbar = true
            this.mensagem = r.message
            this.listaUsuario()
        })
    },
    buscaGrupo(id) {
        //console.log(id)
        for(let i in this.getGrupos) {
            for(let _id in this.getGrupos[i].usuarios_id){
               // console.log('ids', this.getGrupos[i].usuarios_id[_id] == id)
               if(this.getGrupos[i].usuarios_id[_id] == id) {
                   return this.getGrupos[i].nome
               }

               //else return 'Nenhum'
            }
        }
    },
  },
  computed:{
    ...mapGetters(['getUsuarios', 'getGrupos', 'getUser']),
    validate()
    {
      return !!(
        this.usuarioSelected.nome && /^[a-z0-9.]+@[a-z0-9]+\.[a-z]+(\.[a-z]+)?$/i.test(this.usuarioSelected.login) &&
        this.usuarioSelected.endereco.logradouro && this.usuarioSelected.endereco.numero && this.usuarioSelected.endereco.bairro &&
        this.usuarioSelected.endereco.cidade && this.usuarioSelected.endereco.estado && this.usuarioSelected.endereco.cep
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/empresa/ListarUsuarios.vue